import React from "react";
import Shared from "../../../../components/ReUseAbleComponents/Shared";

import { Link } from "react-router-dom";
import ReactSelect from "react-select";
import product1xspng from "../../../../assets/images/product-1-xs.png";
import product2xspng from "../../../../assets/images/product-2-xs.png";
import product3xspng from "../../../../assets/images/product-3-xs.png";
import product4xspng from "../../../../assets/images/product-4-xs.png";
import product5xspng from "../../../../assets/images/product-5-xs.png";

function SubmitTicket(props) {
  const categories = [
    { id: 1, image: product1xspng, name: "Product 1" },
    { id: 2, image: product2xspng, name: "Product 2" },
    { id: 3, image: product3xspng, name: "Product 3" },
    { id: 4, image: product4xspng, name: "Product 4" },
    { id: 5, image: product5xspng, name: "Product 5" },
  ];
  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#2b72e6" : "white",
        color: isFocused && "#ffff",
      };
    },
  };

  return (
    <>
      <Shared />

      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <div className="dx-box dx-box-decorated">
                <div className="dx-box-content">
                  <h2 className="h6 mb-6">Submit a Ticket</h2>

                  <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-6 fs-14">
                    <li>
                      <Link to="/help-center">Support Home</Link>
                    </li>
                    <li>
                      <Link to="/ticket">Ticket System</Link>
                    </li>
                    <li>Submit Ticket</li>
                  </ul>
                </div>
                <div className="dx-separator"></div>
                <div className="dx-box-content">
                  <form action="#" className="dx-form">
                    <div className="dx-form-group">
                      <label for="select-product" className="mnt-7">
                        Select Product
                      </label>

                      <ReactSelect
                        className="form-control dx-select-ticket"
                        options={categories}
                        styles={customStyles}
                        placeholder="Choose one..."
                        formatOptionLabel={(category) => (
                          <div className="country-option">
                            <img src={category.image} alt="cat-logo" />
                            <span>{category.name}</span>
                          </div>
                        )}
                      />
                    </div>
                    <div className="dx-form-group">
                      <Link
                        to="/ticket-submit-2"
                        className="dx-btn dx-btn-block dx-btn-xl dx-btn-envato d-flex align-items-center justify-content-center"
                      >
                        <span className="fas fa-leaf mr-20"></span>
                        <span>Log in with Envato</span>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubmitTicket;
